import Login from "features/login/login";
import ForgotPassword from "features/forgotPassword/forgotPassword";
import SetPassword from "features/setPassword/setPassword";
import NotFound from "features/notFound/notFound";
import Projects from "features/projects/projects";
import Register from "features/register/register";
import Unauthorized from "features/unauthorized/unauthorized";
import Users from "features/users/users";
import GuestPageLayout from "layout/guestPageLayout";
import LoggedInPageLayout from "layout/loggedInPageLayout";
import K from "utilities/constants";
import AccountSetting from "features/accountSettings/accountSettings";
import Notifications from "features/notifications/notifications";
import ErrorPage from "features/errorPage/errorPage";
import ResolveitChat from "features/resolveitchat/resolveitchat";
import ResolveitSiderLayout from "layout/resolveitSiderLayout";
import ResolveitSearch from "features/resolveitchat/resolveitSearchNotification";
import JournalRequest from "features/resolveitchat/journalRequest";
import Personality from "features/register/personality";
import DeclinedRequest from "features/unauthorized/declinedrequest/declinedRequestPage";
import JournalChat from "features/resolveitchat/journalChat";
import JournalAIChat from "features/resolveitchat/JournalAIChat";
import BlockRequest from "features/blocked/blockRequest";
import SubInfo from "features/sub-info/subInfo";
import PersonalityTest from "features/sub-info/personalityTest";

// Template for a route
// {
//   path: '/login',
//   name: "Login",
//   component: Login,
//   authenticated: true,
//   roles: [],
//   children: [],
//   exact: true,
//   layout: LoggedInPageLayout
// },

const defaultCrudChildren = [
  { path: "/details/:id", name: "Details" },
  { path: "/store/:id", name: "Edit" },
];

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: GuestPageLayout,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    layout: GuestPageLayout,
  },
  {
    path: "/personality",
    name: "Personality",
    component: Personality,
    layout: GuestPageLayout,
    authenticated: true,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    layout: GuestPageLayout,
  },
  {
    path: "/sub-info",
    name: "SubInfo",
    component: SubInfo,
    layout: GuestPageLayout,
    authenticated: true,
  },
  {
    path: "/personality-test",
    name: "PersonalityTest",
    component: PersonalityTest,
    layout: GuestPageLayout,
  },
  {
    path: "/reset-password",
    name: "SetPassword",
    component: SetPassword,
    layout: GuestPageLayout,
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects,
    authenticated: true,
    roles: [K.Roles.Admin],
    exact: true,
    children: defaultCrudChildren,
    layout: LoggedInPageLayout,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    authenticated: true,
    roles: [],
    children: defaultCrudChildren,
    layout: LoggedInPageLayout,
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
    authenticated: true,
    roles: [],
    layout: GuestPageLayout,
  },
  {
    path: "/block-request",
    name: "BlockRequest",
    component: BlockRequest,
    authenticated: true,
  },

  {
    path: "/declined-request",
    name: "DeclinedRequest",
    component: DeclinedRequest,
    layout: GuestPageLayout,
  },
  // {
  //   path: "/",
  //   name: "MyDiaries",
  //   exact: true,
  //   component: MyDiaries,
  //   authenticated: true,
  //   layout: LoggedInPageLayout,
  // },
  // {
  //   path: "/",
  //   name: "DiaryEntry",
  //   exact: true,
  //   component: DiaryEntry,
  //   authenticated: true,
  //   layout: LoggedInPageLayout,
  // },

  {
    path: "/",
    name: "ResolveitChat",
    exact: true,
    component: ResolveitChat,
    authenticated: true,
    layout: ResolveitSiderLayout,
  },
  {
    path: "/journal-request",
    name: "JournalRequest",
    exact: true,
    component: JournalRequest,
    authenticated: true,
    layout: ResolveitSiderLayout,
  },
  {
    path: "/daily-chat",
    name: "JournalChat",
    exact: true,
    component: JournalChat,
    authenticated: false,
    layout: ResolveitSiderLayout,
  },
  {
    path: "/journal-ai-chat",
    name: "JournalAIChat",
    exact: false,
    component: JournalAIChat,
    authenticated: false,
    layout: ResolveitSiderLayout,
  },
  {
    path: "/notifications",
    name: "Notifications",
    exact: true,
    component: Notifications,
    authenticated: true,
    layout: LoggedInPageLayout,
  },

  {
    path: "/account-settings",
    name: "AccountSetting",
    exact: true,
    component: AccountSetting,
    authenticated: true,
    layout: LoggedInPageLayout,
  },

  {
    path: "/resolveit-search",
    name: "resolveitSearch",
    exact: true,
    component: ResolveitSearch,
    authenticated: true,
    layout: ResolveitSiderLayout,
  },
  {
    path: "/404",
    name: "ErrorPage",
    component: ErrorPage,
    layout: LoggedInPageLayout,
  },
  {
    path: "*",
    name: "Not Found",
    component: NotFound,
    layout: GuestPageLayout,
  },
];

export default routes;
